import React from 'react';

const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: { height: 36 },
    default: { height: 48 },
    large: { height: 64 },
  };

  const { height } = sizes[size] || sizes.default;

  return (
    <img
      src="/tsvmap-logo.png"
      alt="TSVMap"
      style={{ height }}
      className={className}
    />
  );
};

export default Logo;
